export const RESET = 'EXCMAGREEMENT_LIST_RESET'
export const SET_ITEMS = 'EXCMAGREEMENT_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMAGREEMENT_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMAGREEMENT_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMAGREEMENT_LIST_TOGGLE_LOADING'
